import { CSmartTable } from '@coreui/react-pro'
import VideoCameraFront from '@mui/icons-material/VideoCameraFront'
import { Button } from '@mui/material'
import dayjs from 'dayjs'
import capitalize from 'lodash/capitalize'
import tokenBackgroundIcon from 'src/assets/svg/hp-token-icon.svg'
import ConsultsActions from 'src/clinic/components/ClinicManageBookingsPage/consultsTab/components/ConsultsActions'
import { getBookedSlotStripColor } from 'src/clinic/components/ClinicManageBookingsPage/DayViewCalendarComponent'
import ContactDetailsTableItem from 'src/clinic/components/ClinicManageBookingsPage/slotItem/component/ContactDetailsTableItem'
import InTherapyButton from 'src/clinic/components/ClinicManageBookingsPage/slotItem/component/InTherapyButton'
import { ConsultsTabTableContainer } from 'src/clinic/components/ClinicManageBookingsPage/slotItem/styledComponent'
import { shouldShowPrescriptionPdfDownloadButtons } from 'src/clinic/components/ClinicManageBookingsPage/utils'
import { MOMENT_FORMATS } from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { getCSmartTableColumnData, getExactTimeDiff } from 'src/consumer/helpers/utilFunctions'
import { preparePatientLabelFromPatientInfoObject } from 'src/supportPortal/views/scheduledPatients/utils'

export default function ConsultsTab({
  bookedEventsListWithPatientInfo,
  loadingTableData,
  viewButtonClick,
  showActionButtons = false,
  mentorProfileData,
  clinicLocationData,
  handleNewTherapyRequest,
  setClickedBookedSlotData,
  therapyBookingDataForThisEvent,
  setEditPatientDialogOpen,
  forMentor,
  setAddVitalsDialogOpen,
  setEditBookingDialogOpen,
  refreshBookedSlots,
  sendPrescriptionPdfApiSignature,
  prescriptionGetApiSignature,
  prescriptionSaveApiSignature,
  fileUploadApiSignature,
  showGalleryForPrescriptionImages,
  sendSecureSessionLinkToPatientSignature,
  sendPublicSessionLinkToPatientSignature,
  prescriptionImagesGetApiSignature,
  prescriptionImagesSaveApiSignature,
  prescriptionViewSettings,
}) {
  const finalBInfoTableItems = bookedEventsListWithPatientInfo?.map((event) => {
    return {
      ...event,
      _props: {
        // className: `odd:bg-row1 even:bg-row2 dark:odd:bg-row1Dark listing-font-medium dark:even:bg-row2Dark ${
        //   item._props?.className || ''
        // } ${
        //   enabledParam !== undefined && !item?.[enabledParam]
        //     ? 'row-item-disabled'
        //     : 'row-item-enabled'
        // }`,
        style: {
          verticalAlign: 'middle',
          background: getBookedSlotStripColor(event).consultsTableColor,
        },
        // onMouseEnter: () => {
        //   console.log('mouseEnter')
        // },
        // onMouseLeave: () => {
        //   console.log('mouseEnter')
        // },
      },
      // _props: {
      //     style: {
      //         background: getBookedSlotStripColor(event).consultsTableColor,
      //         verticalAlign: 'center'
      //     },
      // },
    }
  })
  console.log({ bookedEventsListWithPatientInfo, finalBInfoTableItems })

  return (
    <ConsultsTabTableContainer>
      <CSmartTable
        items={finalBInfoTableItems.sort((a, b) => {
          return a.markedCompleted === b.markedCompleted ? 0 : a.markedCompleted ? 1 : -1
        })}
        columns={columns({ viewButtonClick, showActionButtons })}
        loading={loadingTableData}
        tableProps={{
          hover: true,
          striped: true,
          responsive: true,
        }}
        // columnSorter
        // pagination
        // onColumnFilterChange={(filter) => {
        //   getDataWithSortPageOrSize(1)
        //   setColumnFilter(filter)
        // }}
        // onItemsPerPageChange={(pageSize) => {
        //   getDataWithSortPageOrSize(1, undefined, pageSize)
        //   setItemsPerPage(pageSize)
        // }}
        itemsPerPage={10000000000000000}
        scopedColumns={scopedColumns({
          viewButtonClick,
          mentorProfileData,
          clinicLocationData,
          handleNewTherapyRequest,
          setClickedBookedSlotData,
          therapyBookingDataForThisEvent,
          setEditPatientDialogOpen,
          forMentor,
          setAddVitalsDialogOpen,
          setEditBookingDialogOpen,
          refreshBookedSlots,
          prescriptionViewSettings,
          sendPrescriptionPdfApiSignature,
          prescriptionGetApiSignature,
          prescriptionSaveApiSignature,
          fileUploadApiSignature,
          showGalleryForPrescriptionImages,
          sendSecureSessionLinkToPatientSignature,
          sendPublicSessionLinkToPatientSignature,
          prescriptionImagesGetApiSignature,
          prescriptionImagesSaveApiSignature,
        })}
      />
    </ConsultsTabTableContainer>
  )
}

function columns({ hideClinicDetails = false, viewButtonClick, showActionButtons }) {
  let columns = [
    getCSmartTableColumnData({
      key: 'patientInfoNumber',
      label: 'Patient ID',
      filter: false,
      sorter: false,
      _style: { maxWidth: '100px' },
    }),
    getCSmartTableColumnData({
      key: 'appointmentNumber',
      label: 'Token',
      filter: false,
      sorter: false,
      _style: { width: '170px', minWidth: '170px' },
    }),
    getCSmartTableColumnData({
      key: 'name',
      label: 'Patient Name',
      filter: false,
      sorter: true,
      _style: { minWidth: '150px' },
    }),
    getCSmartTableColumnData({
      key: 'view',
      label: viewButtonClick ? 'View' : 'Session Info',
      filter: false,
      sorter: false,
      _style: { maxWidth: '150px' },
    }),
    getCSmartTableColumnData({
      key: 'bookingTime',
      label: 'Booking Time',
      filter: false,
      sorter: false,
      _style: { maxWidth: '150px' },
    }),
    getCSmartTableColumnData({
      key: 'visitNumber',
      label: 'Visits#',
      filter: false,
      sorter: false,
      _style: { maxWidth: '150px' },
    }),
    getCSmartTableColumnData({
      key: 'waitTime',
      label: 'Wait Time',
      filter: false,
      sorter: false,
      _style: { maxWidth: '150px' },
    }),
    getCSmartTableColumnData({
      key: 'purpose',
      label: 'Purpose',
      filter: false,
      sorter: false,
      _style: { maxWidth: '150px' },
    }),
  ]

  if (showActionButtons) {
    columns.push(
      getCSmartTableColumnData({
        key: 'actions',
        label: 'Actions',
        filter: false,
        sorter: false,
        _style: { maxWidth: '90px' },
      }),
    )
  }
  return columns
}

function scopedColumns({
  viewButtonClick,
  mentorProfileData,
  clinicLocationData,
  handleNewTherapyRequest,
  setClickedBookedSlotData,
  therapyBookingDataForThisEvent,
  setEditPatientDialogOpen,
  forMentor,
  setAddVitalsDialogOpen,
  setEditBookingDialogOpen,
  refreshBookedSlots,
  prescriptionViewSettings,
  sendPrescriptionPdfApiSignature,
  prescriptionGetApiSignature,
  prescriptionSaveApiSignature,
  fileUploadApiSignature,
  showGalleryForPrescriptionImages,
  sendSecureSessionLinkToPatientSignature,
  sendPublicSessionLinkToPatientSignature,
  prescriptionImagesGetApiSignature,
  prescriptionImagesSaveApiSignature,
}) {
  return {
    // TODO: add online of offline session info here
    latestVisit: (patInfo) => <td></td>,
    appointmentNumber: (bookedEventInfo) => {
      return (
        <td>
          <div
            style={{
              position: 'relative',
              width: '100%',
              minHeight: '40px', // or whatever works for your design
              backgroundImage: `url(${tokenBackgroundIcon})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain', // or '100% 100%' if you want full fit
              backgroundPosition: 'center',
            }}
            className="d-flex flex-column align-items-center justify-content-center"
          >
            <div
              style={{
                color: '#8f8f9f',
                zIndex: 1,
                position: 'relative',
                width: '100%',
              }}
              className="d-flex justify-content-center align-items-center gap-1"
            >
              <span>{bookedEventInfo?.appointmentNumber}</span>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-1">
              {bookedEventInfo?.meetingSrc === 'aumhum' ? <VideoCameraFront /> : null}
            </div>
          </div>
        </td>
      )
    },
    patientInfoNumber: (bookedEventInfo) => {
      const patientInfo = bookedEventInfo?.patientInfo
      return (
        <td>
          <div className="d-flex gap-1" style={{ height: '100px' }}>
            {bookedEventInfo?.therapyPatient && (
              <InTherapyButton bookedSlot={bookedEventInfo} slotBlocked={false} />
            )}
            <div style={{ color: '#8f8f9f' }} className="d-flex align-items-center gap-1">
              <span>
                {patientInfo?.patientNumber || patientInfo?.patientNumber ? (
                  <>{patientInfo?.patientNumber || patientInfo?.patientNumber}</>
                ) : (
                  <>Patient no. not assigned</>
                )}
              </span>
            </div>
          </div>
        </td>
      )
    },
    name: (bookedEventInfo) => {
      const patientInfo = bookedEventInfo?.patientInfo
      return (
        <td>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-center gap-1">
              <span>{preparePatientLabelFromPatientInfoObject(patientInfo, true)}</span>
            </div>
            ({getAgeFromDobWithTime(patientInfo?.dateOfBirth)} Y /{capitalize(patientInfo?.gender)})
            <ContactDetailsTableItem bookedEventInfo={bookedEventInfo} isTableItem={false} />
          </div>
        </td>
      )
    },
    contactDetails: (bookedEventInfo) => {
      return (
        <td>
          <ContactDetailsTableItem bookedEventInfo={bookedEventInfo} isTableItem={false} />
        </td>
      )
    },
    bookingTime: (bookedEventInfo) => {
      return (
        <td>
          <div className="d-flex flex-column gap-1">
            <div>
              <span>
                {bookedEventInfo?.startTime
                  ? dayjs
                      .utc(bookedEventInfo?.startTime)
                      .local()
                      .format(MOMENT_FORMATS.formattedTime24Hrs)
                  : 'No Data'}
              </span>
            </div>
          </div>
        </td>
      )
    },
    waitTime: (bookedEventInfo) => {
      const slotStart = bookedEventInfo?.startTime
        ? dayjs.utc(bookedEventInfo.startTime).local()
        : null
      const sessionStart = bookedEventInfo?.sessionStartedAt
        ? dayjs.utc(bookedEventInfo.sessionStartedAt).local()
        : null

      let content = '--'

      if (sessionStart && slotStart) {
        // Case 1: Session started — show difference between sessionStart and slotStart
        content = getExactTimeDiff(slotStart, sessionStart, false, false, false)
      } else if (slotStart) {
        if (slotStart.isSame(dayjs(), 'day')) {
          // Case 2: No session start, but slotStart is today — show wait time since slotStart
          content = getExactTimeDiff(slotStart, dayjs(), false, false, false)
        }
      }

      return (
        <td>
          <div className="d-flex flex-column gap-1">
            <div>
              <span>{content}</span>
            </div>
          </div>
        </td>
      )
    },
    view: (bookedEventInfo) => {
      // If viewButtonClick is not provided (e.g., for Clinic Assistants), show meaningful information instead
      if (!viewButtonClick) {
        const sessionStatus = bookedEventInfo?.markedCompleted
          ? 'Completed'
          : bookedEventInfo?.sessionStartedAt
          ? 'In Progress'
          : 'Upcoming'
        
        const platformType = bookedEventInfo?.meetingSrc === 'aumhum' ? 'Online' : 'Offline'
        const eventType = bookedEventInfo?.title || bookedEventInfo?.eventType || 'Session'
        
        return (
          <td>
            <div className="d-flex flex-column gap-1" style={{ fontSize: '12px' }}>
              <div style={{ fontWeight: 600, color: '#333' }}>
                {sessionStatus}
              </div>
              <div style={{ color: '#666' }}>
                {platformType} • {eventType}
              </div>
              {bookedEventInfo?.sessionStartedAt && (
                <div style={{ color: '#888', fontSize: '11px' }}>
                  Started: {dayjs.utc(bookedEventInfo.sessionStartedAt).local().format('HH:mm')}
                </div>
              )}
            </div>
          </td>
        )
      }
      
      // For mentors, show the View button
      return (
        <td>
          <Button
            variant="contained"
            onClick={() => {
              viewButtonClick(bookedEventInfo)
            }}
          >
            View
          </Button>
        </td>
      )
    },
    visitNumber: (bookedEventInfo) => {
      return (
        <td>
          {bookedEventInfo?.patientMeetingSeqNumber
            ? bookedEventInfo?.patientMeetingSeqNumber
            : '--'}
        </td>
      )
    },
    purpose: (bookedEventInfo) => {
      return <td>{bookedEventInfo?.title ? bookedEventInfo?.title : '--'}</td>
    },
    actions: (bookedEventInfo) => {
      return (
        <td>
          <ConsultsActions
            bookedSlot={bookedEventInfo}
            mentorProfileData={mentorProfileData}
            clinicLocationData={clinicLocationData}
            handleNewTherapyRequest={handleNewTherapyRequest}
            setClickedBookedSlotData={setClickedBookedSlotData}
            therapyBookingDataForThisEvent={therapyBookingDataForThisEvent}
            setEditPatientDialogOpen={setEditPatientDialogOpen}
            forMentor={forMentor}
            setAddVitalsDialogOpen={setAddVitalsDialogOpen}
            setEditBookingDialogOpen={setEditBookingDialogOpen}
            refreshBookedSlots={refreshBookedSlots}
            showPrescriptionPdfDownloadButtons={shouldShowPrescriptionPdfDownloadButtons({
              forMentor,
              bookedSlot: bookedEventInfo,
              prescriptionViewSettingsData: prescriptionViewSettings,
            })}
            sendPrescriptionPdfApiSignature={sendPrescriptionPdfApiSignature}
            prescriptionGetApiSignature={prescriptionGetApiSignature}
            prescriptionSaveApiSignature={prescriptionSaveApiSignature}
            fileUploadApiSignature={fileUploadApiSignature}
            showGalleryForPrescriptionImages={showGalleryForPrescriptionImages}
            sendSecureSessionLinkToPatientSignature={sendSecureSessionLinkToPatientSignature}
            sendPublicSessionLinkToPatientSignature={sendPublicSessionLinkToPatientSignature}
            prescriptionImagesGetApiSignature={prescriptionImagesGetApiSignature}
            prescriptionImagesSaveApiSignature={prescriptionImagesSaveApiSignature}
          />
        </td>
      )
    },
  }
}
